import React, { useCallback } from 'react';
import moment from 'moment';
import { Chip, Link, Typography } from '@material-ui/core';
import ListarDatos from '../../../../general/ListarDatos';
import { BtnVer, BtnDescargar } from '../../../../general/BotonesAccion';
import TareasTerminadas from '../../../../general/TareasTerminadas';
import emma_w from './../../../../../global/imagenes/emma_w.png';
import {
    obtenerEstadoVisualFicha,
    obtenerMensajeEstadoFicha,
    obtenerFechaUltimaFicha,
    obtenerUltimoEditorFicha,
} from '../../helpers/bienestarFichaUtils';

const AVATAR_GRIS = { backgroundColor: '#d1d1d1ff', color: '#FFFFFF' };

const ESTILO_ESTADO = {
    BORRADOR: { backgroundColor: '#fff3e0', color: '#e65100' },
    CAMBIOS_PENDIENTES: { backgroundColor: '#fff8e1', color: '#8d6e00' },
    FINALIZADO: { backgroundColor: '#e8f5e9', color: '#2e7d32' },
};

function DetalleFichaSeguimientoTab({
    fichas,
    cargando,
    usuarioActual,
    onSeleccionarFicha,
}) {
    const handleSeleccionar = useCallback((row) => {
        if (typeof onSeleccionarFicha === 'function') {
            onSeleccionarFicha(row);
        }
    }, [onSeleccionarFicha]);

    if (cargando) {
        return (
            <TareasTerminadas
                mensaje='Cargando..'
                marginTop='7%'
                imagen={emma_w}
                widthImg='7%'
                cargando={true}
            />
        );
    }

    return (
        <ListarDatos
            datos={fichas}
            id='tbl_ficha_seguimiento_bienestar'
            avatar={({ nombre }) => nombre ? nombre.charAt(0).toUpperCase() : 'F'}
            color_avatar={() => AVATAR_GRIS}
            fila_principal={({ secundario }) => secundario?.nombre ? secundario.nombre.toUpperCase() : 'Sin nombre'}
            filas={[
                { id: 'descripcion', mostrar: ({ secundario }) => secundario?.descripcion || 'Sin descripción' },
                {
                    id: 'ultimo_editor',
                    nombre: 'Último guardado por:',
                    mostrar: (row) => row?.ultimo_guardado_por || obtenerUltimoEditorFicha(row, usuarioActual) || 'Sin información',
                },
                {
                    id: 'ultima_actualizacion',
                    nombre: 'Fecha última actualización:',
                    mostrar: (row) => {
                        const fecha = row?.fecha_ultima_actualizacion || obtenerFechaUltimaFicha(row);
                        return fecha ? moment(fecha).format('YYYY-MM-DD, h:mm a') : 'Sin información';
                    },
                },
                {
                    id: 'aviso_regenerar',
                    nombre: '',
                    mostrar: (row) => {
                        const { estado } = obtenerEstadoVisualFicha(row);
                        const mensajeEstado = obtenerMensajeEstadoFicha(estado);
                        if (!mensajeEstado) return '';
                        return (
                            <Typography variant='caption' style={{ color: '#8d6e00', fontWeight: 600 }}>
                                {mensajeEstado}
                            </Typography>
                        );
                    },
                },
            ]}
            acciones={(row) => {
                const { estado: estadoVisual, ultimoPdf } = obtenerEstadoVisualFicha(row);
                const estiloEstado = ESTILO_ESTADO[estadoVisual] || ESTILO_ESTADO.FINALIZADO;
                return (
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center' }}>
                        <BtnVer callback={() => handleSeleccionar(row)} />
                        {estadoVisual && ultimoPdf?.archivo && (
                            <>
                                <Chip
                                    label={String(estadoVisual || '').replace(/_/g, ' ')}
                                    size='small'
                                    style={{
                                        fontWeight: 600,
                                        fontSize: '0.7rem',
                                        ...estiloEstado,
                                    }}
                                />
                                <Link href={ultimoPdf.archivo} target='_blank' rel='noopener noreferrer'>
                                    <BtnDescargar callback={() => { }} />
                                </Link>
                            </>
                        )}
                    </div>
                );
            }}
        />
    );
}

export default React.memo(DetalleFichaSeguimientoTab);
